import { replace, fillFragment } from './replace';

const keys = ['temperature-low'];

function lensColumnSpanPath(columnName, mode) {
  return [
    'tables',
    'basic' /* TODO: it should be dynamic property */,
    'content',
    columnName,
    'modes',
    mode,
    'colspan',
  ];
}

function shiftOrReplace($pool, $dataProxy) {
  return function run(eventName, payload) {
    const { Controller, columnName, mode, newMode } = payload;

    if (eventName !== 'Row:changeMode') return;
    if (!keys.includes(Controller.name)) return;

    /* 3-hour to 8-hour */
    if (mode === 't' && newMode === 'p') {
      let newCells;
      let fragment;

      $pool.push('Table:changeMode::idle', () => {
        newCells = payload[newMode].cells.map(cell => cell.cloneNode(true));
        fragment = fillFragment(newCells);
      });

      $pool.push('Table:changeMode::mutate', () => {
        replace(Controller, fragment);

        // eslint-disable-next-line no-param-reassign
        payload.Controller.cells = newCells;
      });

      return;
    }

    const newColspan = $dataProxy.path(lensColumnSpanPath(columnName, newMode));

    /* 3-hour to 1-hour or vice versa */
    if (
      (mode === 't' && newMode === 'h') ||
      (mode === 'h' && newMode === 't')
    ) {
      const el = Controller.cells[0];

      $pool.push('Table:changeMode::mutate', () => {
        el.setAttribute('colspan', newColspan);
      });

      return;
    }

    let newCell;
    /* 8-hour to 3-hour */
    $pool.push('Table:changeMode::idle', () => {
      const last = Controller.cells[Controller.cells.length - 1];
      newCell = last.cloneNode(true);
      newCell.firstElementChild.innerHTML = '-';
      newCell.setAttribute('colspan', newColspan);
    });

    $pool.push('Table:changeMode::mutate', () => {
      replace(Controller, newCell);

      /* eslint-disable-next-line no-param-reassign */
      payload.Controller.cells = [newCell];
    });
  };
}

export default shiftOrReplace;
